import(/* webpackMode: "eager" */ "/var/app/admin-portal/src/components/terms/Terms.tsx")